import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  Table,
  UncontrolledTooltip,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import PaginationV2 from "../../components/Pagination/PaginationV2";
import { map } from "lodash";
import { listStatusEmployees } from "../../common/data";
import Select from "react-select";
import Breadcrumbs from "/src/components/Common/Breadcrumb";
import { getEmployeesAdmin, getCostCentersAdmin, getOrgsAdmin } from "../../helpers/api_rombo_helper";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import AdminModal from "./AdminModal";
import DeleteModal from "./DeleteModal";
import DeleteBulkModal from "./DeleteBulkModal";
import i18n from "../../i18n";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "../../components/Common/Spinner";
import { orgId } from "../../constants/utils";
import { Permissions } from "../../constants/enums";

const AdminEmployees = () => {
  document.title = `${i18n.t("Employees")} - ${orgId}`;

  const dispatch = useDispatch();

  const [adminModal, setAdminModal] = useState(false);
  const toggleViewModal = () => setAdminModal(!adminModal);

  const [createModal, setCreateModal] = useState(false);
  const toggleViewModalCreate = () => setCreateModal(!createModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const toggleViewModalDelete = () => setDeleteModal(!deleteModal);

  const [deleteBulkModal, setDeleteBulkModal] = useState(false);
  const toggleViewModalDeleteBulk = () => setDeleteBulkModal(!deleteBulkModal);

  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [clickDeleteEmployee, setClickDeleteEmployee] = useState(false);
  const [checkDeleteEmployees, setCheckDeleteEmployees] = useState([]);
  const [reloadEmployee, setReloadEmployee] = useState(false);
  const [findEmployees, setFindEmployees] = useState([]);
  const [responseEmployees, setResponseEmployees] = useState({});

  const [fStatus, setFStatus] = useState(null);
  const [fCompany, setFCompany] = useState(null);
  const [costCenterId, setCostCenterId] = useState(null);
  const [shouldShowCostCenter, setShouldShowCostCenter] = useState(true);

  const [opts, setOpts] = useState([]);
  const [listCompanies, setListCompanies] = useState([]);
  const [optSelectCostCenters, setOptSelectCostCenters] = useState([]);

  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [textHeader, setTextHeader] = useState('');
  const [textBody, setTextBody] = useState('');

  const [infoUser, setInfoUser] = useState({ permissions: [] });   

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
      lastPath: Login.lastPath
    })
  );

  const { token, loading, data, lastPath } = useSelector(LoginProperties);

  const [isLoading, setLoading] = useState(true);
  const [drp_link, setDrp_link] = useState(false);

  const autoformik = useFormik({
    initialValues: {
      search: "",
      email: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      email: Yup.string()
    })
  });

  useEffect(() => {
    if (fCompany || infoUser?.partner_id) {
      onGetEmployeesAdmin();
      onGetCostCentersAdmin();
      const hideCostCenter = Number(fCompany) === 6823 || Number(infoUser.partner_id) === 6823;
      setShouldShowCostCenter(!hideCostCenter);
    } else {
      setLoading(false);
      setFindEmployees([]);
      setOptSelectCostCenters([]);
    }
  
    if (localStorage.getItem("notify") == "true") {
      setShowAlertSuccess(true);
      setTextHeader(localStorage.getItem("headerText"));
      setTextBody(localStorage.getItem("bodyText"));
      localStorage.setItem("notify", "false");
    }
  }, [dispatch, reloadEmployee, infoUser?.partner_id]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  useEffect(() => {
    initCheckBox()
    onCheckSelectEmployee();
  }, [findEmployees]);

  useEffect(() => {
    searchFilters(null, "company")
  }, [fCompany]);

  useEffect(() => {
    searchFilters(null, "all")
  }, [fStatus, costCenterId]);

  useEffect(() => {
    onGetOrgsAdmin()
  }, []);

  const onGetCostCentersAdmin = () => {
    if (!fCompany && !infoUser?.partner_id) {
      setOptSelectCostCenters([]);
      return;
    }
  
    const params = {
      partner_id: fCompany || infoUser?.partner_id
    };
  
    getCostCentersAdmin(token, params)
      .then((response) => {
        let arr = [];
        map(response.items, (costCenter, id) => {
          arr.push({
            id: costCenter.id,
            label: costCenter.name,
            value: costCenter.id,
            totalBudget: costCenter.total_budget,
            totalTrips: costCenter.total_trips,
            chargeType: costCenter.charge_type,
            serviceType: costCenter.service_type,
          });
        });
        setOptSelectCostCenters(arr);
      })
      .catch((error) => {
        console.error("Error - getCostCentersAdmin - ", error);
        setOptSelectCostCenters([]);
      });
  };

  const onGetOrgsAdmin = () => {
    let arr = []
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const onClickDeleteEmployee = (args, type, e) => {
    let deleteEmployees = checkDeleteEmployees;
  
    if (type === "one") {
      if (e.target.checked) {
        deleteEmployees.push(args);
        setCheckDeleteEmployees(deleteEmployees);
      } else {
        let checkDeleteEmployee = deleteEmployees.filter(function (opt) {
          return opt.id === args.id;
        });
  
        if (checkDeleteEmployee.shift()) {
          deleteEmployees.splice(deleteEmployees.indexOf(checkDeleteEmployee.shift()), 1);
        }
      }
    } else {
      let arrFindEmployees = [];
      setCheckDeleteEmployees(arrFindEmployees);
  
      if (e.target.checked) {
        findEmployees.map((item) => {
          arrFindEmployees.push(item);
          document.getElementById(`check-${item.id}`)
            ? (document.getElementById(`check-${item.id}`).checked = true)
            : null;
        });
        setCheckDeleteEmployees([...arrFindEmployees]);
      } else {
        findEmployees.map((item) => {
          document.getElementById(`check-${item.id}`)
            ? (document.getElementById(`check-${item.id}`).checked = false)
            : null;
        });
      }
    }
  };  

  const searchFilters = (value, type) => {
    if (!fCompany && !infoUser?.partner_id) {
      setFindEmployees([]);
      return;
    }
  
    setFindEmployees([]);
    var newOpts = {
      name: type == "name" ? value : autoformik.values.search,
      email: type == "email" ? value : autoformik.values.email,
      status: fStatus,
      partner_id: fCompany || infoUser?.partner_id,
      page: 1,
      size: 10
    }
    onGetEmployeesAdmin(newOpts);
  };

  const onChangePagePaginate = (page) => {
    if (!fCompany && !infoUser?.partner_id) {
      setFindEmployees([]);
      return;
    }
  
    setFindEmployees([]);
    var newOpts = {
      name: autoformik.values.search,
      email: autoformik.values.email,
      status: fStatus,
      partner_id: fCompany || infoUser?.partner_id,
      page: page,
      size: 10
    }
    onGetEmployeesAdmin(newOpts);
  };

  const onGetEmployeesAdmin = (newOpts = opts) => {
    if (!newOpts.partner_id && !infoUser?.partner_id) {
      setLoading(false);
      setFindEmployees([]);
      return;
    }
  
    if (infoUser?.partner_id && !newOpts.partner_id) {
      newOpts = {...newOpts, partner_id: infoUser.partner_id};
    }
  
    setLoading(true);
    getEmployeesAdmin(token, newOpts)
      .then((response) => {
        setLoading(false);
        setResponseEmployees(response);
        setOpts(newOpts);
        setFindEmployees([...response.items]);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error - getEmployeesAdmin - ", error);
      });
  };  
 
  const onClickDelete = (employees) => {
    setSelectedEmployee(employees);
    setDeleteModal(true);
  };
 
  const initCheckBox = () => {
    var checkboxes = document.getElementsByClassName("checksEmployees")
    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false
    }
  };
 
  const onCheckSelectEmployee = () => {
    checkDeleteEmployees.forEach(({ id }) => {
      const checkbox = document.getElementById(`check-${id}`);
      if (checkbox) {
        checkbox.checked = true;
      }
    });
  };

  const hashStringToIndex = (str, max) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash % max);
  };
  
  const getAvatarColor = (employee) => {
    const colors = [
      'avatar-color-1',
      'avatar-color-2',
      'avatar-color-3',
      'avatar-color-4',
      'avatar-color-5',
      'avatar-color-6',
      'avatar-color-7',
      'avatar-color-8'
    ];
  
    const baseString = employee.name || employee.email || String(employee.id);
    const index = hashStringToIndex(baseString, colors.length);
    return colors[index];
  };   
 
  return (
    <Fragment>
      <div className="page-content">
        <Breadcrumbs title={i18n.t("Employees")} breadcrumbItem={i18n.t("AdminEmployees")} />
          <Card>
            <CardBody className="pb-2">
              <Row className="pb-2">
                <Col xs={12} xl={12} md={12} className="pb-2">
                  <Row>
                    <Col xxl={9} md={7} xs={12}>
                      <CardTitle className="h4">{i18n.t("AdminEmployees")}</CardTitle>
                      {!fCompany && !infoUser?.partner_id && (
                        <span className="error-message-requests">
                          <i className="fa fa-exclamation-circle"></i>
                          {i18n.t("SelectAPartnerToVisualize")}
                        </span>
                      )}
                    </Col>
                    <Col xxl={12} className="d-flex justify-content-end align-items-start mb-4">
                      <Row>
                        <Col xxl={8} md={8} xs={8}>
                          <AdminModal 
                            isOpen={adminModal}
                            setReloadEmployee={setReloadEmployee}
                            token={token}
                            listCompanies={listCompanies}
                            infoUser={infoUser}
                            reloadEmployee={reloadEmployee}
                            toggle={toggleViewModal}
                            setAdminModal={setAdminModal}
                            setShowAlertSuccess={setShowAlertSuccess}
                            setTextHeader={setTextHeader}
                            setTextBody={setTextBody}
                          />
                          <DeleteBulkModal
                            checkDeleteEmployees={checkDeleteEmployees}
                            setClickDeleteEmployee={setClickDeleteEmployee}
                            token={token}
                            setReloadEmployee={setReloadEmployee}
                            reloadEmployee={reloadEmployee}
                            setCheckDeleteEmployees={setCheckDeleteEmployees}
                            isOpen={deleteBulkModal}
                            toggle={toggleViewModalDeleteBulk}
                            setDeleteBulkModal={setDeleteBulkModal}
                            setShowAlertSuccess={setShowAlertSuccess}
                            setTextHeader={setTextHeader}
                            setTextBody={setTextBody}
                          />
                          {
                            clickDeleteEmployee ? (
                              <button 
                                onClick={toggleViewModalDeleteBulk} 
                                disabled={checkDeleteEmployees.length === 0} 
                                className="btn btn-request"
                              >
                                {i18n.t("DeleteEmployee")}
                              </button>
                            ) : (
                              infoUser.permissions.includes(Permissions.CREATE_EMPLOYEE) && (
                                <button 
                                  onClick={toggleViewModal} 
                                  className="btn btn-request"
                                >
                                  {i18n.t("AdminEmployees")}
                                </button>
                              )
                            )
                          }
                        </Col>
                        <Col xxl={4} md={4} xs={4} className="d-flex text-start">
                          <Col xxl={6} md={6} xs={6}>
                            <ButtonDropdown isOpen={drp_link} toggle={() => { setDrp_link(!drp_link) }}>
                              <DropdownToggle className="btn btn-employees-options px-3" caret color="secondary">
                                ⋮
                              </DropdownToggle>
                              <DropdownMenu className="custom-dropdown-menu">
                                {infoUser.permissions.includes(Permissions.CREATE_EMPLOYEE) && (
                                  <DropdownItem>
                                    <Link to={'create'}>{i18n.t("CreateEmployee")}</Link>
                                  </DropdownItem>
                                )}
                                {infoUser.permissions.includes(Permissions.DELETE_EMPLOYEE) && (
                                  <DropdownItem onClick={() => setClickDeleteEmployee(!clickDeleteEmployee)}>
                                    {i18n.t("DeleteEmployee")}
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                            </ButtonDropdown>
                          </Col>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} xl={12} md={12} className="pb-2">
                <div className="orange-separator" />
                  <Form className="row gy-2 gx-3" onSubmit={autoformik.handleSubmit}>
                    {infoUser.is_staff && (
                      <Col xxl={2} md={2} xs={12}>
                        <Card className="mb-1">
                          <Select
                            name="company"
                            placeholder={i18n.t("Partner")}
                            options={listCompanies}
                            isClearable
                            className="select2-selection"
                            value={listCompanies.find(({ value }) => value === fCompany) ?? null} 
                            onChange={(e) => {
                              setFCompany(e?.value); 
                              onChangeFilters("company", e);
                            }}
                          />
                        </Card>
                      </Col>
                    )}
                    <Col xxl={3} md={3} xs={12}>
                      <div className="col-sm-auto">                        
                        <Input
                          type="text"
                          name="search"
                          className="employees-input"
                          id="searchInput"
                          placeholder={i18n.t("SearchName")}
                          value={autoformik.values.search}
                          onChange={(e) => {
                            autoformik.handleChange(e);
                            searchFilters(e.target.value, "name")
                          }}
                          invalid={
                            autoformik.touched.search && autoformik.errors.search ? true : false
                          }
                        />
                        {autoformik.errors.search && autoformik.touched.search && (
                          <FormFeedback type="invalid">
                            {autoformik.errors.search}
                          </FormFeedback>
                        )}
                      </div>
                    </Col>
                    <Col xxl={2} md={2} xs={12} >
                      <div className="col-sm-auto">
                        <Input
                          type="text"
                          name="email"
                          className="employees-input"
                          id="emailInput"
                          placeholder={i18n.t("Email")}
                          value={autoformik.values.email}
                          onChange={(e) => {
                            autoformik.handleChange(e);
                            searchFilters(e.target.value, "email")
                          }}
                          invalid={
                            autoformik.touched.email && autoformik.errors.email ? true : false
                          } 
                        />
                        {autoformik.errors.email && autoformik.touched.email && (
                          <FormFeedback type="invalid">
                            {autoformik.errors.email}
                          </FormFeedback>
                        )}
                      </div>
                    </Col>
                    <Col xxl={2} md={2} xs={12}>
                      <Card className="mb-1">
                        <Select
                          name="status"
                          placeholder={i18n.t("Status")}
                          options={listStatusEmployees}
                          isClearable
                          className="select2-selection"
                          onChange={ (e) => {
                            setFStatus(e?.value)
                          }}
                        />
                      </Card>
                    </Col>
                  </Form>
                  <div className="orange-separator margin-separator" />
                  <div className="table-responsive pt-3">
                    <Table className="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline">
                      {(fCompany || infoUser?.partner_id) && (
                        <thead>
                          <tr>
                            <th className="table-header2">
                              <Input
                                type="checkbox"
                                id="checkAll"
                                className={`${clickDeleteEmployee ? "" : "d-none p-0 m-0"}`}
                                onClick={(e) => onClickDeleteEmployee(null, "all", e)}
                              />
                            </th>
                            <th className="table-header2">{i18n.t("#")}</th>
                            <th className="table-header2">{i18n.t("Name")}</th>
                            <th className="table-header2">{i18n.t("Email")}</th>
                            <th className="table-header2">{i18n.t("Phone")}</th>
                            {shouldShowCostCenter && (
                              <th className="table-header2">{i18n.t("CostCenter")}</th>
                            )}
                            <th className="table-header2">{i18n.t("Department")}</th>
                            <th className="table-header2">{i18n.t("NoEmployee")}</th>
                            {infoUser.is_staff && (
                              <th className="table-header2">{i18n.t("Partner")}</th>
                            )}
                            <th className="table-header2">{i18n.t("Status")}</th>
                            {(infoUser.permissions.includes(Permissions.WRITE_EMPLOYEE) || 
                            infoUser.permissions.includes(Permissions.DELETE_EMPLOYEE)) && (
                              <th className="table-header2">{i18n.t("Actions")}</th>
                            )}
                          </tr>
                        </thead>
                      )}
                        {!fCompany && !infoUser?.partner_id ? (
                          <tr>
                            <td colSpan="9" className="text-center">
                            <i className="bx bx-group icon-no-results"></i>
                            </td>
                          </tr>
                        ) : (
                          <tbody className="fs-13">
                            {map(findEmployees, (employee, key) => (
                              <tr key={key}>
                                <td>
                                  <Input
                                    type="checkbox"
                                    id={`check-${employee.id}`}
                                    className={`checksEmployees ${clickDeleteEmployee ? "" : "d-none p-0 m-0"}`}
                                    name="checksEmployees"
                                    onClick={(e) => onClickDeleteEmployee(employee, "one", e)}
                                  />
                                </td>
                                <td>
                                  <i className={`bx bx-user employee-avatar ${getAvatarColor(employee)}`} />
                                </td>
                                <td>{employee.name}</td>
                                <td>{employee.email}</td>
                                <td>{employee.phone}</td>
                                {shouldShowCostCenter && (
                                  <td>{employee.cost_center?.name || "-"}</td>
                                )}
                                <td>{employee.depot}</td>
                                <td>{employee.identifier}</td>
                                {infoUser.is_staff && <td>{employee.partner_name}</td>}
                                <td>
                                  <div
                                    className={`employee-status ${
                                      employee.status === "ACTIVE"
                                        ? "employee-status-active"
                                        : "employee-status-inactive"
                                    }`}
                                  >
                                    {i18n.t(employee.status)}
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex">
                                    {infoUser.permissions.includes(Permissions.WRITE_EMPLOYEE) && (
                                      <Link
                                        to={`edit/${employee.id}`}
                                        className="btn btn-edit waves-effect waves-light mx-1 edit-button"
                                        id={`edittooltip-${employee.id}`}
                                      >
                                        <i className="mdi mdi-pencil font-size-18 edit-icon"></i>
                                        <UncontrolledTooltip placement="top" target={`edittooltip-${employee.id}`}>
                                          {i18n.t("Edit")}
                                        </UncontrolledTooltip>
                                      </Link>
                                    )}
                                    {infoUser.permissions.includes(Permissions.DELETE_EMPLOYEE) && (
                                      <button
                                        className="btn btn-deleted-request waves-effect waves-light mx-1"
                                        onClick={() => onClickDelete(employee)}
                                        id={`deletetooltip-${employee.id}`}
                                      >
                                        <i className="mdi mdi-delete font-size-18 deleted-icon" />
                                        <UncontrolledTooltip placement="top" target={`deletetooltip-${employee.id}`}>
                                          {i18n.t("Eliminated")}
                                        </UncontrolledTooltip>
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                    </Table>
                    {isLoading ? (
                      <Spinners setLoading={setLoading} />
                    ) : (
                      (fCompany || infoUser?.partner_id) && (
                        <PaginationV2
                          currentPage={responseEmployees.page}
                          pageSize={responseEmployees.size}
                          totalItems={responseEmployees.total}
                          onChangePage={onChangePagePaginate}
                        />
                      )
                    )}
                    <DeleteModal
                      setReloadEmployee={setReloadEmployee}
                      reloadEmployee={reloadEmployee}
                      selectedEmployee={selectedEmployee}
                      setSelectedEmployee={setSelectedEmployee}
                      isOpen={deleteModal}
                      toggle={toggleViewModalDelete}
                      setDeleteModal={setDeleteModal}
                      setShowAlertSuccess={setShowAlertSuccess}
                      setTextHeader={setTextHeader}
                      token={token}
                      setTextBody={setTextBody}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      <AlertSuccess
        showAlertSuccess={showAlertSuccess}
        setShowAlertSuccess={setShowAlertSuccess}
        textHeader={textHeader}
        textBody={textBody}
      />
    </Fragment>
  )
}

AdminEmployees.propTypes = {
  onGetEmployees: PropTypes.func
}

export default AdminEmployees;
